/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Item from "../models/Item";
import Test from "../models/Test";
import TestPart from "../models/TestPart";
import Section from "../models/Section";
import PnpItem from "../models/PnpItem";

class AdaptiveTestModelBuilder {
    private static readonly IDENTIFIER_ATTRIBUTE = "identifier";
    private static readonly TITLE_ATTRIBUTE = "title";

    public static build(responseDataMap: Map<string, never>): Item | null {
        if (!responseDataMap) {
            return null;
        }

        const testData: Map<string, never> = responseDataMap.get("data")!;

        const test: Test = new Test(testData.get(AdaptiveTestModelBuilder.IDENTIFIER_ATTRIBUTE)!, testData.get(AdaptiveTestModelBuilder.TITLE_ATTRIBUTE)!);

        const testPartArray: Array<Map<string, never>> = testData.get("testParts")!;
        const testPart: TestPart = new TestPart(testPartArray[0].get(AdaptiveTestModelBuilder.IDENTIFIER_ATTRIBUTE)!, null, null);

        const sectionArray: Array<Map<string, never>> = testPartArray[0].get("sections")!;
        const section: Section = new Section(sectionArray[0].get(AdaptiveTestModelBuilder.IDENTIFIER_ATTRIBUTE)!, sectionArray[0].get(AdaptiveTestModelBuilder.TITLE_ATTRIBUTE)!, true, true);

        const pnpArray: Array<Map<string, string>> = sectionArray[0].get("pnpItems")!;
        for (let i = 0; i < pnpArray.length; i++) {
            const currentPnp: Map<string, string> = pnpArray[i];
            section.addPnpItem(new PnpItem(currentPnp.get("name")!));
        }

        const itemArray: Array<Map<string, never>> = sectionArray[0].get("items")!;
        const item: Item = new Item(itemArray[0].get(AdaptiveTestModelBuilder.IDENTIFIER_ATTRIBUTE)!, itemArray[0].get("name")!, itemArray[0].get("qti")!);
        item.state = itemArray[0].get("state")!;
        item.currentItem = itemArray[0].get("currentItem")!;

        section.addItem(item);
        testPart.addSection(section);
        test.addTestPart(testPart);

        return item;
    }


    private static getValue<T = never>(value: T, defaultValue: T): T {
        if (value === undefined) {
            return defaultValue;
        }

        return value;
    }
}

export default AdaptiveTestModelBuilder;
